import useBreakpoint from "hooks/useBreakpoint";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import clsx from "clsx";
import SwapCoin from "components/SwapCoin";
import { Drawer, Popover } from "antd";
import requestService from "api/request";
import { formatNumber, formatVolume } from "lib/helpers/format";
import ListCoinTrading from "components/ListCoinTrading";
import OrderBook from "components/OrderBook";
import HistoryTrading from "components/HistoryTrading";
import { useTranslation } from "react-i18next";
import SwapCoinFutrue from "components/ButtonTrade";
import HistoryFuture from "components/HistoryFutrue";
const TradingFutrue = () => {
  const container = useRef<any>();
  const [isInitialized, setIsInitialized] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const [tokenDetail, setTokenDetail] = useState<any>(null);
  const { t, i18n } = useTranslation();
  const [tab, setTab] = useState<string>("chart");
  const [symbol, setSymbol] = useState<string>(
    searchParams.get("symbol") || "BTC"
  );
  const breakpoint = useBreakpoint();

  const [openDrawerSwap, setOpenDrawerSwap] = useState(false);
  const [openListCoin, setOpenListCoin] = useState(false);

  const getLocale = () => {
    if (i18n.language === "vi") return "vi_VN";
    if (i18n.language === "en") return "en";
    if (i18n.language === "cn") return "zh_CN";
    if (i18n.language === "kr") return "ko_KR"; // Korean
    if (i18n.language === "jp") return "ja_JP"; // Japanese
    if (i18n.language === "sg") return "zh_SG"; // Chinese (Singapore)
    if (i18n.language === "th") return "th_TH"; // Thai
    return "vi_VN"; // Default to Vietnamese
  };
  const updateScript = useCallback(() => {
    if (container.current && document) {
      while (container.current && container.current.firstChild) {
        container.current.removeChild(container.current.firstChild);
      }

      // Create new script
      const script = document.createElement("script");
      script.src =
        "https://s3.tradingview.com/external-embedding/embed-widget-advanced-chart.js";
      script.type = "text/javascript";
      script.async = true;
      const widgetConfig = {
        autosize: true,
        symbol: `${symbol}USDT`,
        interval: "15",
        timezone: "Etc/UTC",
        theme: "dark",
        style: "1",
        locale: "en",
        allow_symbol_change: false,
        calendar: false,
        container_id: "tradingview_widget_container",
        support_host: "https://www.tradingview.com",
      };
      script.innerHTML = JSON.stringify(widgetConfig);
      container.current.appendChild(script);
    }
  }, [symbol, i18n.language]);

  useEffect(() => {
    if (container.current && !isInitialized) {
      updateScript();
      setIsInitialized(true);
    } else if (container.current) {
      setTimeout(updateScript, 200);
    }
  }, [symbol, isInitialized, updateScript, tab, i18n.language]);

  const getTokenDetail = useCallback(async () => {
    try {
      const res = await requestService.get("/guest/tokens/" + symbol);
      if (res && res.data) {
        setTokenDetail(() => res.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  }, [symbol]);


  useEffect(() => {
    if (searchParams.get("symbol")) {
      setSymbol(searchParams.get("symbol") || "BTC");
    }
  }, [searchParams]);


  function calculateHighLowPrices(currentPrice: any, percentChange24h: any) {
    const percentChangeDecimal = percentChange24h / 100;

    let highestPrice, lowestPrice;

    if (percentChange24h >= 0) {
      // Percentage change is positive
      highestPrice = currentPrice + currentPrice * percentChangeDecimal;
      lowestPrice = currentPrice - currentPrice * percentChangeDecimal;
    } else {
      // Percentage change is negative
      highestPrice = currentPrice - currentPrice * percentChangeDecimal;
      lowestPrice = currentPrice + currentPrice * percentChangeDecimal;
    }

    return {
      highestPrice: highestPrice,
      lowestPrice: lowestPrice,
    };
  }

  useEffect(() => {
    const intervalId = setInterval(() => {
      getTokenDetail();
    }, 1000); // Adjust the interval time (in milliseconds) as needed

    // Call getTokenDetail immediately when symbol or getTokenDetail changes
    getTokenDetail();

    // Cleanup interval on component unmount or when dependencies change
    return () => clearInterval(intervalId);
  }, [symbol, getTokenDetail]);

  return (
    <div className="MainContainerWrapper-sc-hiue6p-0 jJgYbV">
      <Drawer
        title={t("Danh sách coin")}
        onClose={() => setOpenListCoin(false)}
        open={openListCoin}
        placement="bottom"
        height={600}
      >
        <ListCoinTrading setOpenListCoin={setOpenListCoin} />
      </Drawer>

      <Drawer
        title="symbol"
        onClose={() => setOpenDrawerSwap(false)}
        open={openDrawerSwap}
        placement="bottom"
        height={600}
      >
        <SwapCoinFutrue token={tokenDetail} />
      </Drawer>
      <div className="body-wrapper">
        <div
          className={clsx({
            "LayoutContainerWrapper-sc-bvzt27-0 Yhncx theme- bg-backgroundSecondary px-[8px] pb-[8px] pc-spot":
              breakpoint === "desktop",
            "LayoutContainerWrapper-sc-bvzt27-0 fIuXzq theme- bg-backgroundPrimary h5-spot":
              breakpoint !== "desktop",
          })}
        >
          {breakpoint === "desktop" && (
            <div className="h-[32px]">
              <div className="eNWJ4NsVtUVJ4MGGr7vy h-[32px]">
                <div className="flex px-[4px] overflow-hidden w-[100%] flex-row bg-backgroundSecondary zjU1qn1TJy19zTld04dI">
                  <div
                    className="flex items-center overflow-hidden"
                    translate="no"
                  >
                    <div className="vuOHheKjoru5nifqMRLk">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={14}
                        height={14}
                        viewBox="0 0 14 14"
                        fill="none"
                      >
                        <path
                          d="M11.3211 6.42547C11.0608 5.83944 10.6824 5.31342 10.2096 4.88031L9.81911 4.52222C9.80588 4.51031 9.78992 4.50184 9.77263 4.49756C9.75535 4.49329 9.73728 4.49333 9.72002 4.49769C9.70276 4.50206 9.68683 4.51061 9.67366 4.52258C9.66049 4.53456 9.65047 4.5496 9.64448 4.56637L9.47035 5.06671C9.36194 5.38064 9.1618 5.70096 8.87877 6.01637C8.86446 6.03182 8.84483 6.04128 8.82383 6.04286C8.81334 6.04389 8.80275 6.04268 8.79277 6.03929C8.78279 6.03591 8.77364 6.03044 8.76595 6.02324C8.75683 6.01523 8.74969 6.00521 8.74509 5.99398C8.74049 5.98274 8.73857 5.97059 8.73946 5.95849C8.78851 5.15108 8.54766 4.24017 8.01887 3.2493C7.58181 2.42521 6.97405 1.78311 6.2152 1.33526L5.66091 1.00906C5.64418 0.999618 5.62524 0.99481 5.60604 0.995132C5.58684 0.995455 5.56807 1.0009 5.55167 1.01089C5.53527 1.02089 5.52184 1.03509 5.51276 1.05201C5.50368 1.06893 5.49928 1.08797 5.50001 1.10717L5.52945 1.75074C5.54956 2.19074 5.49854 2.57973 5.37787 2.90348C5.22971 3.30016 5.01671 3.66948 4.74754 3.99637C4.55722 4.22692 4.34384 4.43491 4.11035 4.61444C3.5448 5.04938 3.08498 5.60663 2.76532 6.24446C2.46683 6.84684 2.30207 7.50663 2.28234 8.17862C2.26262 8.85061 2.38838 9.51893 2.65103 10.1378C3.13378 11.2625 4.03518 12.1553 5.16449 12.6272C5.74594 12.8713 6.37042 12.9964 7.00103 12.9951C7.63131 12.9962 8.25549 12.8716 8.83707 12.6287C9.39771 12.3954 9.90754 12.0552 10.3381 11.627C10.7771 11.1945 11.1256 10.6788 11.3633 10.1102C11.6009 9.54156 11.723 8.93129 11.7224 8.31498C11.7224 7.66062 11.5884 7.02489 11.3211 6.42547Z"
                          fill="url(#paint0_linear_6455_70835)"
                        />
                        <defs>
                          <linearGradient
                            id="paint0_linear_6455_70835"
                            x1="7.00135"
                            y1="0.995117"
                            x2="7.00135"
                            y2="12.9951"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="#F45F4F" />
                            <stop offset={1} stopColor="#F1493F" />
                          </linearGradient>
                        </defs>
                      </svg>
                    </div>
                    <div className="relative overflow-hidden mr-[7px] flex justify-between items-center !pr-[9px] ml-[4px]">
                      <div className="auto-scroll-container">
                        <div className="flex items-center w-max">
                          <div className="ooDTV4lSwRhmAT4EK6By">
                            <span>IO/USDT</span>
                            <span className="eRG37Oaxs0JjzdqyzJQv">+8.47%</span>
                          </div>
                          <div className="ooDTV4lSwRhmAT4EK6By">
                            <span>NOT/USDT</span>
                            <span className="eRG37Oaxs0JjzdqyzJQv">
                              +10.98%
                            </span>
                          </div>
                          <div className="ooDTV4lSwRhmAT4EK6By">
                            <span>MAND/USDT</span>
                            <span className="eRG37Oaxs0JjzdqyzJQv">
                              +156.92%
                            </span>
                          </div>
                          <div className="ooDTV4lSwRhmAT4EK6By">
                            <span>BGB/USDT</span>
                            <span className="Jt4VNE6FoeMSKyp5I6jV">-0.55%</span>
                          </div>
                          <div className="ooDTV4lSwRhmAT4EK6By">
                            <span>PIRATE/USDT</span>
                            <span className="eRG37Oaxs0JjzdqyzJQv">
                              +38.34%
                            </span>
                          </div>
                          <div className="ooDTV4lSwRhmAT4EK6By">
                            <span>TONCOIN/USDT</span>
                            <span className="eRG37Oaxs0JjzdqyzJQv">+2.12%</span>
                          </div>
                          <div className="ooDTV4lSwRhmAT4EK6By">
                            <span>BTC/USDT</span>
                            <span className="Jt4VNE6FoeMSKyp5I6jV">-0.74%</span>
                          </div>
                          <div className="ooDTV4lSwRhmAT4EK6By">
                            <span>PEPE/USDT</span>
                            <span className="Jt4VNE6FoeMSKyp5I6jV">-1.31%</span>
                          </div>
                          <div className="ooDTV4lSwRhmAT4EK6By">
                            <span>BWB/USDT</span>
                            <span className="eRG37Oaxs0JjzdqyzJQv">+9.77%</span>
                          </div>
                          <div className="ooDTV4lSwRhmAT4EK6By">
                            <span>SOL/USDT</span>
                            <span className="Jt4VNE6FoeMSKyp5I6jV">-2.12%</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {breakpoint === "desktop" && (
            <div className="!rounded-[8px] overflow-hidden">
              <div className="ca2FLzIthmN88x8xI241 flex justify-between w-full items-start pt-[11px] pl-[12px] pr-[12px] pb-[3px] rounded-[8px]">
                <div className="q2vIQfy6q802II9m7UBc">
                  <div
                    className="RZXeeslw6zDf3sQFzej7 cdZ5LRHawuEBXZ4GUFZR flex justify-start items-start self-stretch relative"
                    style={{ marginRight: 0 }}
                  >
                    <div className="Kg9ZBymFV5mAegc8ORJf relative flex items-center h-[40px] pr-[16px] font-normal text-[16px] leading-[12px]">
                      <div className="w-[32px] h-[32px] me-[8px]">
                        <img
                          width={32}
                          height={32}
                          className="Q13rdX33uJYEoE3CzRsA"
                          src={`https://s2.coinmarketcap.com/static/img/coins/64x64/${tokenDetail?.id}.png`}
                        />
                      </div>
                      <div>
                        <div
                          className="cdZ5LRHawuEBXZ4GUFZR"
                          style={{ marginRight: 0 }}
                        >
                          <h1 className="Cl4K54g1PKAgT1blRU2A UJKz4C7bIys3tRtOn1gj m-0 hover:cursor-pointer min-w-[81.5px]">
                            <span className="text-[18px] font-bold">
                              {tokenDetail?.symbol}/USDT
                            </span>
                            <div className="V4j08JJLcjPVFnQH3lAA w-[16px] h-[16px] ml-[4px] flex justify-center items-center pt-[2px] rounded-[16px] hover:border hover:border-solid">
                              <Popover
                                arrow={false}
                                className="listcoin-trading"
                                placement="bottom"
                                content={
                                  <ListCoinTrading
                                    setOpenListCoin={setOpenListCoin}
                                  />
                                }
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 24 24"
                                  fill="currentColor"
                                  aria-hidden="true"
                                  width={16}
                                  className="shrink-0"
                                >
                                  <path d="M16.835 9.517A.976.976 0 0016.025 8h-8.05a.976.976 0 00-.81 1.517l4.025 6.048a.973.973 0 001.62 0l4.025-6.048z" />
                                </svg>
                              </Popover>
                            </div>
                          </h1>
                        </div>
                        <div
                          className="cdZ5LRHawuEBXZ4GUFZR"
                          style={{ marginRight: 0, alignItems: "end" }}
                        >
                          <span>
                            <a
                              href="#"
                              rel="noreferrer"
                              target="_blank"
                              className="r6p9PeZfP4uOvMkN3VSw fxyb8_0HUvp8PPqWc33g inline-block text-[12px] font-normal leading-[14px] not-italic font-medium mr-[2px] text-left"
                            >
                              {tokenDetail?.name}
                            </a>
                          </span>
                          <span />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="Zou_bUtNO6mjF8FsfrYN qemT13G9BS2nzoYAkr52 flex-1 overflow-y-hidden">
                  <div className="D63HnaXdX9MppbyFVp8R gKJ9bEDaP5smAIJ50Wiw ml-[16px]">
                    <div className="FbofxGyvtOxX_HjpNAmi R_GjNWutvb8tMtfWKof7">
                      <span className="aJZmrYfYiQDUO71MuExA pVsC7zJQIkSA6DQzIOUL FllLwa_ojt9G10k90gWp">
                        {formatNumber(
                          tokenDetail?.quote?.USD?.price?.toFixed(5)
                        )}
                      </span>
                    </div>
                    {/* <div className="RHLdJhiFsdXWCXga_SRH">
                      <span className="pVsC7zJQIkSA6DQzIOUL LehIaXU1BsyOafwsEwLX font-bold">
                        <div>
                          <span>≈</span>
                          <span>₫ 1,685,139,360.06</span>
                        </div>
                      </span>
                    </div> */}
                  </div>
                  <div className="relative flex justify-between w-full text-secondaryText">
                    <div className="overflow-x-scroll scrollbar-hide">
                      <ul className="qemT13G9BS2nzoYAkr52">
                        <li className="D63HnaXdX9MppbyFVp8R gKJ9bEDaP5smAIJ50Wiw l4DghIxDe7YwPBibJZeA">
                          <div className="FbofxGyvtOxX_HjpNAmi">
                            <span>%{t("Biến động 24h")}</span>
                          </div>
                          <div
                            className={clsx("pVsC7zJQIkSA6DQzIOUL ", {
                              FllLwa_ojt9G10k90gWp:
                                tokenDetail?.quote?.USD?.percent_change_24h < 0,
                              DtrBwgVZb2Gw3iHS0q2o:
                                tokenDetail?.quote?.USD?.percent_change_24h > 0,
                            })}
                          >
                            <span
                              className={clsx({
                                LcaGQaer8jnZ3PJeHLlQ:
                                  tokenDetail?.quote?.USD?.percent_change_24h <
                                  0,
                                EcvdiHuvfgxB3EPuJvOx:
                                  tokenDetail?.quote?.USD?.percent_change_24h >
                                  0,
                              })}
                            >
                              {tokenDetail?.quote?.USD?.percent_change_24h?.toFixed(
                                2
                              )}
                              %
                            </span>
                          </div>
                        </li>
                        <li className="gKJ9bEDaP5smAIJ50Wiw">
                          <div className="FbofxGyvtOxX_HjpNAmi">
                            {t("Giá cao 24h")}
                          </div>
                          <div className="pVsC7zJQIkSA6DQzIOUL pYZ3WGMY0ylnOMkHezKD">
                            {formatNumber(
                              calculateHighLowPrices(
                                tokenDetail?.quote?.USD?.price,
                                tokenDetail?.quote?.USD?.percent_change_24h
                              ).highestPrice?.toFixed(6)
                            )}
                          </div>
                        </li>
                        <li className="gKJ9bEDaP5smAIJ50Wiw">
                          <div className="FbofxGyvtOxX_HjpNAmi">
                            {t("Giá thấp 24h")}
                          </div>
                          <div className="pVsC7zJQIkSA6DQzIOUL pYZ3WGMY0ylnOMkHezKD">
                            {formatNumber(
                              calculateHighLowPrices(
                                tokenDetail?.quote?.USD?.price,
                                tokenDetail?.quote?.USD?.percent_change_24h
                              ).lowestPrice?.toFixed(6)
                            )}
                          </div>
                        </li>
                        <li className="gKJ9bEDaP5smAIJ50Wiw">
                          <div className="FbofxGyvtOxX_HjpNAmi">
                            KL 24h ({tokenDetail?.symbol})
                          </div>
                          <div className="pVsC7zJQIkSA6DQzIOUL pYZ3WGMY0ylnOMkHezKD">
                            4.24K
                          </div>
                        </li>
                        <li className="gKJ9bEDaP5smAIJ50Wiw">
                          <div className="FbofxGyvtOxX_HjpNAmi">
                            {t("Khối lượng 24h")} (USDT)
                          </div>
                          <div className="pVsC7zJQIkSA6DQzIOUL pYZ3WGMY0ylnOMkHezKD">
                            281.99M
                          </div>
                        </li>
                        <li className="r0ahyoBtY7CFul77VTqM" />
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="SwmAQSDabILaMdBiCCZ4 mt-[5px] ms-[16px] flex">
                  <button
                    type="button"
                    className="bit-btn css-1qohw99 bit-btn-circle bit-btn-default flex items-center justify-center relative"
                  >
                    <span className="bit-badge css-1qohw99">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                        aria-hidden="true"
                        style={{ width: 16, height: 16 }}
                      >
                        <path d="M21.3 9.795a1.5 1.5 0 001.2-1.47V6A1.5 1.5 0 0021 4.5H3A1.5 1.5 0 001.5 6v2.326a1.5 1.5 0 001.2 1.469 2.25 2.25 0 010 4.406 1.5 1.5 0 00-1.2 1.473V18A1.5 1.5 0 003 19.5h18a1.5 1.5 0 001.5-1.5v-2.326a1.5 1.5 0 00-1.2-1.469 2.25 2.25 0 010-4.406v-.004zM3 15.675a3.75 3.75 0 000-7.35V6h5.25v12H3v-2.325zm18 0V18H9.75V6H21v2.325a3.75 3.75 0 000 7.35z" />
                      </svg>
                    </span>
                  </button>
                </div>
                <div className="SwmAQSDabILaMdBiCCZ4 mt-[5px] ms-[16px] flex">
                  <div className="kUBu95T0OwcuwkhcFdT1">
                    <button
                      type="button"
                      className="bit-btn css-1qohw99 bit-btn-circle bit-btn-default flex items-center justify-center relative"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                        aria-hidden="true"
                        style={{ width: 16, height: 16 }}
                      >
                        <path d="M15.7 9.364c.39.223.521.712.291 1.092l-1.931 3.192a.824.824 0 01-.674.393.83.83 0 01-.704-.337l-1.647-2.268-1.647 2.268a.836.836 0 01-1.144.192.784.784 0 01-.197-1.112l2.317-3.192a.828.828 0 01.67-.338c.268 0 .518.126.671.338l1.585 2.182 1.286-2.127a.834.834 0 011.124-.283z" />
                        <path d="M12.751 2.75a.75.75 0 00-1.5 0v.916A7.5 7.5 0 004.5 11.128c0 3.313-.774 4.848-1.294 5.745A1.5 1.5 0 004.5 19.128h15a1.482 1.482 0 001.298-.75 1.489 1.489 0 00-.003-1.505c-.52-.897-1.295-2.432-1.295-5.745a7.5 7.5 0 00-6.749-7.462V2.75zM19.5 17.628h-15c.724-1.243 1.5-3.119 1.5-6.5a6 6 0 0112 0c0 3.38.775 5.256 1.5 6.5zM15.75 21.378a.75.75 0 01-.75.75H9a.75.75 0 110-1.5h6a.75.75 0 01.75.75z" />
                      </svg>
                    </button>
                  </div>
                </div>
                <div className="T1QKotRLPy3keGkmxkok mt-[5px] ms-[16px]">
                  <button
                    type="button"
                    className="bit-btn css-1qohw99 bit-btn-circle bit-btn-default flex items-center justify-center relative"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                      aria-hidden="true"
                      style={{ width: 16, height: 16 }}
                    >
                      <path d="M21 4.5h-6A3.75 3.75 0 0012 6a3.75 3.75 0 00-3-1.5H3A1.5 1.5 0 001.5 6v12A1.5 1.5 0 003 19.5h6a2.25 2.25 0 012.25 2.25.75.75 0 101.5 0A2.25 2.25 0 0115 19.5h6a1.5 1.5 0 001.5-1.5V6A1.5 1.5 0 0021 4.5zM9 18H3V6h6a2.25 2.25 0 012.25 2.25v10.5A3.732 3.732 0 009 18zm12 0h-6a3.732 3.732 0 00-2.25.75V8.25A2.25 2.25 0 0115 6h6zm-6-9.75h3.75a.75.75 0 110 1.5H15a.75.75 0 110-1.5zM19.5 12a.75.75 0 01-.75.75H15a.75.75 0 110-1.5h3.75a.75.75 0 01.75.75zm0 3a.75.75 0 01-.75.75H15a.75.75 0 110-1.5h3.75a.75.75 0 01.75.75z" />
                    </svg>
                  </button>
                </div>
                <div className="mt-[5px] ms-[16px]">
                  <button
                    type="button"
                    className="bit-btn css-1qohw99 bit-btn-circle bit-btn-default flex items-center justify-center relative btn-bg-color"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                      aria-hidden="true"
                      style={{ width: 16, height: 16 }}
                    >
                      <path d="M12 7.5a4.5 4.5 0 100 9 4.5 4.5 0 000-9zm0 7.5a3 3 0 110-6 3 3 0 010 6zm10.307-4.95a.75.75 0 00-.365-.505L19.146 7.95l-.012-3.152a.751.751 0 00-.265-.57 10.493 10.493 0 00-3.442-1.938.75.75 0 00-.606.056l-2.82 1.576-2.825-1.58a.75.75 0 00-.606-.056A10.51 10.51 0 005.13 4.233a.75.75 0 00-.265.569l-.014 3.155L2.055 9.55a.75.75 0 00-.365.506 9.982 9.982 0 000 3.897.75.75 0 00.365.506l2.797 1.594.01 3.152a.75.75 0 00.266.57 10.491 10.491 0 003.443 1.938.75.75 0 00.605-.056L12 20.077l2.824 1.58a.742.742 0 00.606.054 10.51 10.51 0 003.44-1.944.75.75 0 00.264-.569l.014-3.155 2.797-1.593a.75.75 0 00.365-.507 9.983 9.983 0 00-.003-3.892zm-1.406 3.274l-2.679 1.523a.75.75 0 00-.281.281c-.054.094-.111.194-.17.287a.744.744 0 00-.114.395l-.014 3.023a8.986 8.986 0 01-2.379 1.341l-2.701-1.506a.75.75 0 00-.367-.093H11.837a.758.758 0 00-.384.093l-2.704 1.51a9 9 0 01-2.385-1.334l-.01-3.019a.75.75 0 00-.115-.396 5.367 5.367 0 01-.169-.287.758.758 0 00-.28-.286l-2.682-1.528a8.484 8.484 0 010-2.649l2.674-1.526a.75.75 0 00.28-.281c.055-.094.112-.194.17-.287a.744.744 0 00.115-.395l.014-3.023a8.99 8.99 0 012.378-1.341l2.699 1.506a.75.75 0 00.384.093h.341a.758.758 0 00.385-.093l2.703-1.51c.859.32 1.663.77 2.385 1.334l.01 3.019c.001.14.04.277.115.396.058.093.115.187.169.286.066.12.163.219.281.287l2.681 1.527c.14.879.143 1.774.005 2.653h.004z" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          )}

          {breakpoint !== "desktop" && (
            <div className="tR1LkYVAxbsw5yuuKm77 ps-[16px] pe-[16px] pt-[8px] pb-[20px]">
              <div className="pb-[7px] flex items-center justify-start">
                <div className="me-[8px] w-[28px]">
                  <img
                    width={28}
                    height={28}
                    src={`https://s2.coinmarketcap.com/static/img/coins/64x64/${tokenDetail?.id}.png`}
                  />
                </div>
                <div className="tJmamslaVtlNHLzsAtOx">
                  <h1
                    className="pBAfsaZSCaw1sfiyew6Q"
                    onClick={() => setOpenListCoin(true)}
                  >
                    {tokenDetail?.symbol}/USDT
                    <span className="ea7RtXKPIIWSjXrzA4FQ">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                        aria-hidden="true"
                        width={16}
                        className="shrink-0"
                      >
                        <path d="M16.835 9.517A.976.976 0 0016.025 8h-8.05a.976.976 0 00-.81 1.517l4.025 6.048a.973.973 0 001.62 0l4.025-6.048z" />
                      </svg>
                    </span>
                  </h1>
                  <div className="flex items-center justify-start">
                    <a
                      href="/vi/price/bitcoin"
                      target="_blank"
                      rel="noopener"
                      className="inline-block text-[12px] font-normal leading-[14px] text-left me-[4px] text-contentTertiary"
                    >
                      {tokenDetail?.name}
                    </a>
                    <span className="VWbKwOKmtGtxkb4Ggg8L u9pJd9JwFve6UPtuEXeV" />
                  </div>
                </div>
                <div className="K7zgcz9mT_xvUzT9iGIu">
                  <span className="">
                    {formatNumber(tokenDetail?.quote?.USD?.price?.toFixed(6))}
                  </span>
                </div>
              </div>
              <ul className="PlEZJHwDMl9iKhRrDltp">
                <li>
                  <p>%{t("Biến động 24h")}</p>
                  <span
                    className={clsx({
                      LcaGQaer8jnZ3PJeHLlQ:
                        tokenDetail?.quote?.USD?.percent_change_24h < 0,
                      EcvdiHuvfgxB3EPuJvOx:
                        tokenDetail?.quote?.USD?.percent_change_24h > 0,
                    })}
                  >
                    {tokenDetail?.quote?.USD?.percent_change_24h?.toFixed(2)}%
                  </span>
                </li>
                <li>
                  <p>{t("Giá cao 24h")}</p>
                  <span>
                    {formatNumber(
                      calculateHighLowPrices(
                        tokenDetail?.quote?.USD?.price,
                        tokenDetail?.quote?.USD?.percent_change_24h
                      ).highestPrice?.toFixed(6)
                    )}
                  </span>
                </li>
                <li>
                  <p>{t("Giá thấp 24h")}</p>
                  <span>
                    {formatNumber(
                      calculateHighLowPrices(
                        tokenDetail?.quote?.USD?.price,
                        tokenDetail?.quote?.USD?.percent_change_24h
                      ).lowestPrice?.toFixed(6)
                    )}
                  </span>
                </li>
                <li>
                  <p>KL 24h (BTC)</p>
                  <span>4.34K</span>
                </li>
                <li>
                  <p>{t("Khối lượng 24h")} (USDT)</p>
                  <span>
                    {formatVolume(tokenDetail?.quote?.USD?.volume_24h)}
                  </span>
                </li>
              </ul>
              <button
                type="button"
                className="rounded-[48px] mt-[8px] w-full text-[14px] py-[8px] bg-[#fff] text-[#151717] min-h-[37px] font-[500]"
                onClick={() => setOpenDrawerSwap(true)}
              >
                <span>{t("Giao dịch")}</span>
              </button>
            </div>
          )}
          <div className="h-[8px]"></div>
          <div className="dg0nNsPu9Pl5t_Ts2Vrd">
            <div className="">
              <div
                className={clsx({
                  "E0EeYk2Mp7QGfjymBB9A CRUt4IBz5zT5qcEziCJS":
                    breakpoint === "desktop",
                  "w-full": breakpoint !== "desktop",
                })}
              >
                <div
                  className="vAHGWqwKgZc2GIQER51T"
                  style={{ pointerEvents: "auto" }}
                >
                  <div className="troPhEysTFtXQatd9oh8">
                    <div
                      className="BqxZuBozBCuku6DYk1Zg"
                      style={{ alignSelf: "flex-end", zIndex: 2 }}
                    >
                      <div
                        className={clsx("XqxZRxHH96YCjjh0Yw83 ", {
                          rjr7Ml4rQVjpSrmJ6dGY: tab === "chart",
                        })}
                        onClick={() => setTab("chart")}
                      >
                        {t("Biểu đồ")}
                      </div>
                      {breakpoint !== "desktop" && (
                        <div
                          className={clsx("XqxZRxHH96YCjjh0Yw83 ", {
                            rjr7Ml4rQVjpSrmJ6dGY: tab === "order_book",
                          })}
                          onClick={() => setTab("order_book")}
                        >
                          {t("Sổ lệnh")}
                        </div>
                      )}

                      {breakpoint !== "desktop" && (
                        <div
                          className={clsx("XqxZRxHH96YCjjh0Yw83 ", {
                            rjr7Ml4rQVjpSrmJ6dGY: tab === "_trading",
                          })}
                          onClick={() => setTab("_trading")}
                        >
                          {t("Giao dịch")}
                        </div>
                      )}
                      <div className="XqxZRxHH96YCjjh0Yw83">
                        {t("Tổng ‌quan coin")}
                      </div>
                      {breakpoint !== "desktop" && (
                        <div className="XqxZRxHH96YCjjh0Yw83">
                          {t("Ghi chú")}
                        </div>
                      )}
                    </div>
                  </div>
                  {tab === "chart" && (
                    <div
                      className="ecAqEl_WOPA2mUpm1jBQ"
                      style={{ height: "calc(100% - 40px)" }}
                    >
                      <div
                        className={clsx(
                          "ContractKlineWrapper-sc-19d6756-0 npoUd h-full w-full",
                          {
                            "!h-[404px]": breakpoint !== "desktop",
                          }
                        )}
                      >
                        <div
                          style={{
                            height:
                              breakpoint === "desktop"
                                ? "calc(100% - 44px)"
                                : "100%",
                          }}
                        >
                          <div
                            id="main_chart"
                            style={{ height: "100%" }}
                            ref={container}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                  {tab === "order_book" && (
                    <OrderBook tokenDetail={tokenDetail} />
                  )}
                </div>
                {breakpoint === "desktop" && !!tokenDetail && (
                  <OrderBook tokenDetail={tokenDetail} />
                )}
                {breakpoint === "desktop" && (
                  <div
                    className="CardBodyWrapper-sc-1xm9jjz-4 bzIryo"
                    style={{
                      overflow: "hidden",
                      borderRadius: "0px 0px 4px 4px",
                    }}
                  >
                    <div className="Woq0OLU3EHBrMSk830cf">
                      <ul className="tab-containers vilZo1O0ERsqzXZqTwtf dhh00Jtix866m4TE2I4d">
                        <li className="qq8gvnWhHz6nzamWvKlZ dhh00Jtix866m4TE2I4d">
                          Spot
                        </li>
                        {/* <li className="qq8gvnWhHz6nzamWvKlZ">Cross 3X</li>
                                <li className="qq8gvnWhHz6nzamWvKlZ UWHIhTzVXV9La7jp51fC">
                                  Isolated10X
                                </li> */}
                      </ul>
                      <div className="ecjjy7Le40gRbTLJ0RWq rtl:-scale-x-100">
                        <svg
                          width={40}
                          height={40}
                          viewBox="0 0 40 40"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M4.2565 0H-254C-258.418 0 -262 3.58172 -262 8V54H84V48C84 43.5817 80.4183 40 76 40H37.8617C33.1517 40 28.8773 37.2447 26.9324 32.9549L15.1858 7.04504C13.2409 2.75534 8.96649 0 4.2565 0Z"
                            fill="var(--background-primary)"
                          />
                        </svg>
                      </div>
                    </div>
                    <SwapCoinFutrue token={tokenDetail} />
                  </div>
                )}
                <HistoryFuture />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TradingFutrue;
